class ActivityDetector {
    constructor() {
        this.pointsStorage = new PointsStorage()
        this.areaTrigger = new ScreenAreaTrigger()
        this.initActivityListeners()
    }

    initActivityListeners() {
        isSiteSubsection() ? this.increaseActivityPoint(10) : this.increaseActivityPoint(20)
        $(document).on('mouseleave.detector', this.onMouseLeave.bind(this))
        $(window).on('click.detector', () => this.timer?.start())
        $(window).on('keydown.detector', () => this.timer?.start())
        $(window).on('mousemove.detector', () => this.timer?.start())
        $(window).on('screen:change.detector', this.onScreenChange.bind(this))
    }

    onMouseLeave() {
        this.isActiveUser && $(window).trigger('user:inactive')
    }

    onScreenChange() {
        this.increaseActivityPoint(1)
        this.timer?.start()
    }

    increaseActivityPoint(points) {
        this.pointsStorage.addPoints(points)
        this.isActiveUser && !this.timer && this.startInactivityTimer()
    }

    startInactivityTimer() {
        this.timer = new Timer(60, () => $(window).trigger('user:inactive'))
        this.timer.start()
    }

    removeActivityListeners() {
        $(document).off('mouseleave.detector')
        $(window).off('screen:change.detector')
        $(window).off('click.detector')
        $(window).off('keydown.detector')
        $(window).off('mousemove.detector')
        this.timer?.stop()
    }

    get isActiveUser() {
        return this.pointsStorage.points >= 100
    }
}
